<template>
    <article>
        <v-style>div.modal-wrapper .modal-container .modalBody { width: unset; } #svgfocus { outline: none; }</v-style>
        <PlanoNext
            @search-changed="e => $emit('search-changed', e)"
            :assets="images"
            :locale="$t('trad')"
            :catalogPanes="catalogPanes"
            :catalogItems="catalogItems"
        ></PlanoNext>
    </article>
</template>

<script>
import images from "./images";
import "plano_engine/dist/index.css";
import PlanoNext, { start, stop, Tools, Context, Physics, Toolkit } from "plano_engine";
import { SYSTEM_TYPE } from "@/services/component";

const { Spike } = Physics;
const { TextMenuOption } = Toolkit;

function spike(support, element) {
    return support instanceof Spike;
}

export default {
    props: ["catalogPanes", "catalogItems", "systemType"],
    components: { PlanoNext },
    data: () => ({ images }),
    created() {
        if (!Context.isFixable) {
            this.didChangeIsFixable = true;
            Context.isFixable = () => true;
        }
    },
    mounted() {
        this.originalMenuFn = BoardPaneContent.prototype.createContextMenu;
        let systemType = this.systemType;
        BoardPaneContent.prototype.createContextMenu = function createContextMenu() {
            switch (systemType) {
                case SYSTEM_TYPE.shelf:
                    this._addMenuOption(
                        Context.generateLaddersMenuOption.instance(() => {
                            this.editLadderGeneration();
                        })
                    );
                    break;
                case SYSTEM_TYPE.caddy:
                    this._addMenuOption(
                        Context.generateFixingsMenuOption.instance(() => {
                            this.editFixingGeneration();
                        })
                    );
                    break;
                case SYSTEM_TYPE.newTile:
                    this._addMenuOption(
                        Context.generateHooksMenuOption.instance(() => {
                            this.editHookGeneration();
                        })
                    );
                default:
                    break;
            }

            this._addMenuOption(
                Context.extendsPaneMenuOption.instance(() => {
                    this.editPaneExtension();
                })
            );
        };
        Context.physicsManager.addDenyCarrying(spike);
        Context.activateSelectArea();
        document.addEventListener("keydown", this.onKeydown);
        window.elementDescription = this.elementDescription.bind(this);
    },

    methods: {
        elementDescription(data, validate, cancel) {
            if (data.element instanceof Tools.FavoriteItemBuilder) {
                cancel();
                return;
            }

            const items = [...data.element.currentItems];
            console.assert(items.length === 1, undefined, data);

            this.itemClick(items[0]);

            cancel();
        },
        itemClick(item) {
            const itemDelegate = Object.values(this.catalogItems).find(e => e.id === item.modelId());
            // this is likely a fake item
            if (!itemDelegate) return;

            console.assert(itemDelegate);
            const itemDetails = itemDelegate.data;
            const routeData = this.$router.resolve(`/${itemDetails.type}/${itemDetails.id}`);
            window.open(routeData.href, "_blank");
        },
        onKeydown(event) {
            if (event.ctrlKey || event.metaKey) {
                if (event.key === "s") {
                    event.stopPropagation();
                    event.preventDefault();
                    this.$emit("save");
                }
            }
        }
    },
    beforeDestroy() {
        if (this.didChangeIsFixable) {
            Context.isFixable = undefined;
        }
        BoardPaneContent.prototype.createContextMenu = this.originalMenuFn;
        Context.physicsManager.denyCarryingPredicates.remove(spike);
        window.elementDescription = undefined;
        document.removeEventListener("keydown", this.onKeydown);
    }
};
</script>
<style lang="scss" scoped>
article {
    flex-grow: 1;
    display: flex;
    justify-content: stretch;
}
</style>



// WEBPACK FOOTER //
// plano-engine.vue?07e8e1ce